import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KnBrOrderHistoryEffects } from './kn-br-order-history.effects';
import { knBrOrderHistoryReducer } from './kn-br-order-history.reducer';
import { KN_BR_ORDER_HISTORY_FEATURE } from './kn-br-order-history.state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(KN_BR_ORDER_HISTORY_FEATURE, knBrOrderHistoryReducer),
    EffectsModule.forFeature([KnBrOrderHistoryEffects]),
  ],
})
export class KnBrOrderHistoryStateModule {}
